<template>
  <div class="row">
    <div class="col col-8">
      <component :is="$store.state.calculators.calculator" />
    </div>
    <Navigation />
  </div>
</template>

<script>
import Navigation from '../../Navigation';

export default {
  components: {
    Navigation,
    ConfidenceInterval: async () => import('./ConfidenceInterval.vue'),
    MeanMedianMode: async () => import('./MeanMedianMode.vue'),
    Kurtosis: async () => import('./Kurtosis.vue'),
    Skewness: async () => import('./Skewness.vue'),
    StandardDeviation: async () => import('./StandardDeviation.vue'),
    CoefficientOfVariation: async () => import('./CoefficientOfVariation.vue'),
  },
};
</script>

<style lang="scss" scoped>
.row {
  margin-top: var(--spacing-140);
}

@include bp($bp-mobile) {
  .row {
    margin: 0 0 var(--spacing-100);
    padding: 0 var(--spacing-12);
  }
}
</style>
